import { humanize } from '@utils';
import { UNITS } from '@components/session-timeline/utils/constants';

export default (value: number, eventName: string): [string, string] => {
  let unit = UNITS[eventName] || '';
  const [bpsValue, bpsUnit] = humanize(value * 1000, '').split(' ');
  unit = `${bpsUnit || ''}${unit || ''}`;
  return [bpsValue, unit];
};
